
import ptMessages from '../locales/pt_PT';

const PtLang = {
    messages: {
        ...ptMessages
    },
    locale: 'pt-PT',

};
export default PtLang;